<!-- Define templates. -->
<!--
<ng-template #virtualFolderHierarchyTitle let-permissionNode="permissionNode"><b>{{this.VirtualFolderHierarchyTitle(permissionNode)}}</b></ng-template>
-->

<!-- Define the component's HTML content. -->
<div class="outer-div">
    <mat-drawer-container class="drawer-container">

        <div class="mat-drawer-content-div">

            <!-- Define the component's action bar (similar to what is used in the form builder). -->
            <div class="action-bar">
                <div class="component-title">{{this.Title}}</div>

                <button mat-flat-button
                        disabled="{{this.NoWorkflowsInHierarchy}}"
                        class="action-item theme-primary-btn"
                        color="primary"
                        (click)="this.generatePermissionsPreview()"
                        matTooltip="{{this.GeneratePreviewButtonTooltip}}"
                        [matTooltipPosition]="this.TooltipPosition">
                    <mat-icon svgIcon="bootstrap-forward"
                              class="generate-preview-mat-icon"
                              aria-hidden="false"
                              aria-label="Generate permissions preview"></mat-icon>
                </button>

            </div>

            <!-- Define the <div/> that contains most of the component's content. -->
            <div class="horizontal-flexbox-div"
                 id="horizontal-flexbox-div">
                <mat-tab-group [selectedIndex]="this.TabGroupSelectedIndex"
                               class="child-components-mat-tab-group">
                    <mat-tab label="Hierarchy">
                        <app-permissions-preview-wf-hierarchy *ngIf="this.SiteWorkflows.length > 0"
                                                              class="mat-tab-child-component"
                                                              [siteWorkflows]="this.SiteWorkflows"
                                                              [workflowsInHierarchy]="this.InitialWorkflowHierarchy"
                                                              (workflowHierarchyUpdated)="this.onWorkflowHierarchyUpdated($event)"></app-permissions-preview-wf-hierarchy>
                    </mat-tab>
                    <mat-tab label="Filters">
                        <app-permissions-preview-filters class="mat-tab-child-component"
                                                         [siteRoles]="this.SiteRoles"
                                                         [selectedRoles]="this.InitiallySelectedRoles"
                                                         (rolesUpdated)="this.onSelectedRolesUpdated($event)"></app-permissions-preview-filters>
                    </mat-tab>
                </mat-tab-group>

                <!-- Define the results <div/>. -->
                <div *ngIf="this.PermissionPreviewNodes != null"
                     class="permission-results-div">
                    <!-- Draw simple HTML table. -->
                    <table class="permission-results-table">
                        <thead>
                            <tr>
                                <!-- Nothing for 'Role' and 'Workflow(s)' -->
                                <td colspan="1"></td>

                                <td [attr.colspan]="this.PermissionsPreviewWorkflowCount"
                                    class="permission-results-table-header-line-one-td">
                                    {{this.PermissionsPreviewWorkflowCount > 1 ? 'Workflows' : 'Workflow'}}
                                </td>

                                <td colspan="5"
                                    class="permission-results-table-header-line-one-td">
                                    Build
                                </td>
                                <td colspan="4"
                                    class="permission-results-table-header-line-one-td">
                                    Perform
                                </td>
                            </tr>
                            <tr>
                                <td class="permission-results-table-header-td">Role</td>

                                <td *ngFor="let wf of this.PermissionsPreviewWorkflowHierarchy"
                                    class="permission-results-table-header-td">
                                    {{wf.name}}
                                </td>

                                <td class="permission-results-table-header-td">Roles</td>
                                <td class="permission-results-table-header-td">Workflows</td>
                                <td class="permission-results-table-header-td">Forms</td>
                                <td class="permission-results-table-header-td">Folders</td>
                                <td class="permission-results-table-header-td">Form Instances</td>

                                <td class="permission-results-table-header-td">View</td>
                                <td class="permission-results-table-header-td">Edit</td>
                                <td class="permission-results-table-header-td">Delete</td>
                                <td class="permission-results-table-header-td">Grant</td>
                            </tr>
                        </thead>

                        <tbody>
                            <ng-container *ngFor="let permissionNode of this.PermissionPreviewNodes; let i=index">
                                <!-- Define templates. -->
                                <ng-container>
                                    <ng-template #virtualFolderHierarchyTitle><b>{{this.VirtualFolderHierarchyTitle(permissionNode)}}</b></ng-template>
                                    <ng-template #virtualFolderHierarchyContent>
                                        <app-virtual-folder-popover [permissionNode]="permissionNode"
                                                                    [clickedPermissionName]="this.ClickedPermissionName(permissionNode)"></app-virtual-folder-popover>
                                    </ng-template>
                                </ng-container>




                                <!-- Define permission rows. -->
                                <!--[triggers]="'manual'"-->
                                <tr class="{{this.PermissionsPreviewRowClass(i)}}"
                                    id="{{this.PermissionNodeId(permissionNode)}}"
                                    [popoverTitle]="virtualFolderHierarchyTitle"
                                    [ngbPopover]="virtualFolderHierarchyContent"
                                    triggers="manual"
                                    [container]="'body'">
                                    <td class="permission-results-table-role-name-td">
                                        {{this.PermissionNodeRoleName(permissionNode,i)}}
                                    </td>

                                    <td *ngFor="let wf of this.PermissionsPreviewWorkflowHierarchy; let wfi=index"
                                        class="permission-results-table-workflow-name-td">
                                        {{this.PermissionNodeWorkflowState(permissionNode,wfi)}}
                                    </td>

                                    <td [ngClass]="permissionNode.canBuildRoles ? 'yes-permission-td' : 'no-permission-td'"
                                        (click)="this.permissionClicked(permissionNode,'canBuildRoles')">
                                        <ng-container *ngIf="permissionNode.canBuildRoles">
                                            <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="!permissionNode.canBuildRoles">
                                            <!--<mat-icon>minimize</mat-icon>-->
                                            x
                                        </ng-container>
                                    </td>
                                    <td [ngClass]="permissionNode.canBuildWorkflows ? 'yes-permission-td' : 'no-permission-td'"
                                        (click)="this.permissionClicked(permissionNode,'canBuildWorkflows')">
                                        <ng-container *ngIf="permissionNode.canBuildWorkflows">
                                            <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="!permissionNode.canBuildWorkflows">
                                            <!--<mat-icon>minimize</mat-icon>-->
                                            x
                                        </ng-container>
                                    </td>
                                    <td [ngClass]="permissionNode.canBuildForms ? 'yes-permission-td' : 'no-permission-td'"
                                        (click)="this.permissionClicked(permissionNode,'canBuildFormInstances')">
                                        <ng-container *ngIf="permissionNode.canBuildForms">
                                            <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="!permissionNode.canBuildForms">
                                            <!--<mat-icon>minimize</mat-icon>-->
                                            x
                                        </ng-container>
                                    </td>

                                    <td [ngClass]="permissionNode.canBuildFolders ? 'yes-permission-td' : 'no-permission-td'"
                                        (click)="this.permissionClicked(permissionNode,'canBuildFolders')">
                                        <ng-container *ngIf="permissionNode.canBuildFolders">
                                            <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="!permissionNode.canBuildFolders">
                                            <!--<mat-icon>minimize</mat-icon>-->
                                            x
                                        </ng-container>
                                    </td>

                                    <td [ngClass]="permissionNode.canBuildFormInstances ? 'yes-permission-td' : 'no-permission-td'"
                                        (click)="this.permissionClicked(permissionNode,'canBuildFormInstances')">
                                        <ng-container *ngIf="permissionNode.canBuildFormInstances">
                                            <mat-icon class="yes-permission-mat-icon">check</mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="!permissionNode.canBuildFormInstances">
                                            <!--<mat-icon>minimize</mat-icon>-->
                                            x
                                        </ng-container>
                                    </td>



                                    <td [ngClass]="permissionNode.canView ? 'yes-permission-td' : 'no-permission-td'"
                                        (click)="this.permissionClicked(permissionNode,'canView')">
                                        <ng-container *ngIf="permissionNode.canView">
                                            <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="!permissionNode.canView">
                                            x
                                        </ng-container>
                                    </td>
                                    <td [ngClass]="permissionNode.canEdit ? 'yes-permission-td' : 'no-permission-td'"
                                        (click)="this.permissionClicked(permissionNode,'canEdit')">
                                        <ng-container *ngIf="permissionNode.canEdit">
                                            <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="!permissionNode.canEdit">
                                            <!--<mat-icon>minimize</mat-icon>-->
                                            x
                                        </ng-container>
                                    </td>

                                    <td [ngClass]="permissionNode.canDelete ? 'yes-permission-td' : 'no-permission-td'"
                                        (click)="this.permissionClicked(permissionNode,'canEdit')">
                                        <ng-container *ngIf="permissionNode.canDelete">
                                            <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="!permissionNode.canDelete">
                                            <!--<mat-icon>minimize</mat-icon>-->
                                            x
                                        </ng-container>
                                    </td>

                                    <td [ngClass]="permissionNode.canGrant ? 'yes-permission-td' : 'no-permission-td'"
                                        (click)="this.permissionClicked(permissionNode,'canGrant')">
                                        <ng-container *ngIf="permissionNode.canGrant">
                                            <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="!permissionNode.canGrant">
                                            <!--<mat-icon>minimize</mat-icon>-->
                                            x
                                        </ng-container>
                                    </td>
                                </tr>

                                <!-- Define conditionally shown inline folder hierarchy records. -->
                                <ng-container *ngIf="false && this.WorkflowHierarchyShown(permissionNode)">
                                    <tr *ngFor="let workflowHierarchyRecord of this.WorkflowHierarchyRecords(permissionNode)"
                                        [ngClass]="permissionNode.transientIsShown ? 'shown-workflow-hierarchy-tr' : 'hidden-workflow-hierarchy-tr'">
                                        <!-- Workflow name. -->
                                        <td [attr.colspan]="1 + this.PermissionsPreviewWorkflowCount"
                                            class="workflow-hierarchy-workflow-name-td">
                                            {{workflowHierarchyRecord.workflowName}}
                                        </td>

                                        <!-- Permission cells. -->
                                        <!-- 'Build' permission cells. -->
                                        <td *ngFor="let permissionCellName of this.BuildPermissionCellNames; let i=index"
                                            [ngClass]="this.CanBuild(workflowHierarchyRecord, permissionCellName) ? 'workflow-hierarchy-permission-cell' : 'workflow-hierarchy-permission-cell'">
                                            <ng-container *ngIf="this.CanBuild(workflowHierarchyRecord, permissionCellName)">
                                                <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                                            </ng-container>
                                            <ng-container *ngIf="!this.CanBuild(workflowHierarchyRecord, permissionCellName)">
                                                <!--<mat-icon>minimize</mat-icon>-->
                                                x
                                            </ng-container>
                                        </td>

                                        <!-- 'Perform' permission cells. -->
                                        <td *ngFor="let permissionCellName of this.PerformPermissionCellNames; let i=index"
                                            [ngClass]="this.CanBuild(workflowHierarchyRecord, permissionCellName) ? 'workflow-hierarchy-permission-cell' : 'workflow-hierarchy-permission-cell'">
                                            <ng-container *ngIf="this.CanPerform(workflowHierarchyRecord, permissionCellName)">
                                                <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                                            </ng-container>
                                            <ng-container *ngIf="!this.CanPerform(workflowHierarchyRecord, permissionCellName)">
                                                <!--<mat-icon>minimize</mat-icon>-->
                                                x
                                            </ng-container>
                                        </td>
                                    </tr>
                                </ng-container>



                                <!-- If this is the last role record, write a members summary. -->
                                <ng-container *ngIf="permissionNode.isLastRoleRecordFlag">
                                    <tr>
                                        <td [attr.colspan]="1 + this.PermissionsPreviewWorkflowCount"
                                            class="role-members-summary-table-header-td">
                                            {{permissionNode.numGroupMembers}} Group Member(s)
                                        </td>
                                        <td colspan="9"></td>
                                    </tr>
                                    <tr>
                                        <td [attr.colspan]="1 + this.PermissionsPreviewWorkflowCount"
                                            class="role-members-summary-table-header-td">
                                            {{permissionNode.numUserMembers}} User Member(s)
                                        </td>
                                        <td colspan="9"></td>
                                    </tr>
                                    <tr *ngIf="!this.IsLastPermissionPreviewNode(i)"
                                        class="role-separator-tr">
                                        <td [attr.colspan]="1 + this.PermissionsPreviewWorkflowCount + 1"></td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!--
        <mat-drawer #permissionsDrawer
                    mode="over"
                    position="end"
                    class="permissions-drawer">
        </mat-drawer>
            -->
    </mat-drawer-container>
</div>
